import * as Yup from 'yup';
import { createImpressionValidation } from './createImpressionValidation';

export const validationSchema = Yup.object().shape({
  premiereImpressions: createImpressionValidation(),
  past30Impressions: createImpressionValidation(['premiereImpressions']),
  past60Impressions: createImpressionValidation([
    'past30Impressions',
    'premiereImpressions',
  ]),
  past90Impressions: createImpressionValidation([
    'past60Impressions',
    'past30Impressions',
    'premiereImpressions',
  ]),
  past365Impressions: createImpressionValidation([
    'past90Impressions',
    'past60Impressions',
    'past30Impressions',
    'premiereImpressions',
  ]),
  station: Yup.object()
    .shape({
      id: Yup.string().required(),
      displayName: Yup.string(),
      type: Yup.string(),
      country: Yup.string(),
      image: Yup.string().nullable(),
    })
    .required('Station is required'),
  premiereDate: Yup.string().required('Required'),
  notes: Yup.string().nullable(),
});
